import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Public from "../views/public.vue";
import PublicLogin from "../views/publicLogin.vue";
import Acceptance from "../views/acceptance.vue";
import AcceptanceLogin from "../views/acceptanceLogin.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home, //公告
  },
  {
    path: "/about",
    name: "About",
    component: About, //公告
  },
  {
    path: "/public",
    name: "Public",
    component: Public, //公示
  },
  {
    path: "/publicLogin",
    name: "PublicLogin",
    component: PublicLogin, //公示
  },
  {
    path: "/acceptance",
    name: "Acceptance",
    component: Acceptance, //受理信息
  },
  {
    path: "/acceptanceLogin",
    name: "AcceptanceLogin",
    component: AcceptanceLogin, //受理信息
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
